import { ReactNode, useState } from 'react';

export interface ConfirmData {
    title: string;
    content: string | ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    isLoading?: boolean;
    variant?: 'default' | 'danger';
}

export interface ConfirmHook {
    /** Current data controlling the modal */
    confirmData?: ConfirmData | null;

    /**
     * Opens the confirm modal.
     * Returns a Promise that resolves when the user confirms or cancels.
     */
    openConfirm: (data: ConfirmData) => Promise<boolean>;

    /** Internally resolves the current confirm promise with true */
    confirm: () => void;

    /** Internally resolves the current confirm promise with false */
    cancel: () => void;
}



export function useConfirm() : ConfirmHook {
    const [confirmData, setConfirmData] = useState<ConfirmData | null>(null);
    const [resolver, setResolver] = useState<(value: boolean) => void>();

    const openConfirm = (data: ConfirmData): Promise<boolean> => {
       
        setConfirmData(data);
        return new Promise<boolean>((resolve) => {
            setResolver(() => resolve);
        });
    };

    const confirm = () => {
        resolver?.(true);
        cleanup();
    };

    const cancel = () => {
        resolver?.(false);
        cleanup();
    };

    const cleanup = () => {
        setConfirmData(null);
        setResolver(undefined);
    };

    return {
        confirmData,
        openConfirm,
        confirm,
        cancel,
    };
}
